var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.8668 9.36435C25.3433 7.84083 23.9938 7.61334 23.3251 7.61334C23.1442 7.61334 23.025 7.63095 22.9824 7.63866C22.81 7.66909 22.6506 7.75202 22.527 7.87586L19.7222 10.6804L19.722 10.6806C19.7214 10.6808 19.7214 10.6811 19.7213 10.6811L9.92859 20.4743C9.9284 20.4745 9.92807 20.4745 9.92789 20.4748C9.9277 20.475 9.92732 20.4754 9.92732 20.4756L9.07575 21.3272C8.95688 21.446 8.87559 21.5976 8.8422 21.7625L7.66447 27.5891C7.6076 27.8698 7.69532 28.1604 7.89802 28.3629C8.0598 28.5248 8.27776 28.6133 8.50228 28.6133C8.55859 28.6133 8.61528 28.6078 8.67163 28.5965L14.4983 27.4186C14.6632 27.3854 14.8144 27.3039 14.9332 27.1852L28.3843 13.7341C28.5131 13.6054 28.5976 13.4388 28.625 13.2586C28.6545 13.0688 28.851 11.3486 26.867 9.3644L26.8668 9.36435ZM15.1815 24.5197L11.7407 21.0795L20.326 12.4942L23.7664 15.9346L15.1815 24.5197ZM9.59483 26.6657L10.4662 22.3537L10.5319 22.2881L13.9723 25.7283L13.9066 25.7939L9.59483 26.6657ZM24.9751 14.7254L21.5349 11.2852L23.4873 9.33274C23.8665 9.37567 24.6761 9.59104 25.6581 10.573C26.6557 11.5708 26.8781 12.3963 26.9246 12.7759L24.9751 14.7254Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.ae34e7205a8fa014ec1b9a754ab86cf6.svg";
export { ForwardRef as ReactComponent };